export enum BettingSelectionsQueryKeys {
  BettingSelections = "bettingSelections",
  BettingSelectionWithTranslations = "bettingSelections.withTranslations",
  BettingSelectionMappings = "bettingSelections.mappings",
  BettingSelectionsSuspensions = "bettingSelectionsSuspensions",
}
